import { useMemo } from "react";

import * as COLUMNS_AVAILABLE from "b2b/components/zdroje-grid-columns/columnsAvailable";

export default function useColumns() {
  const columns = [
    COLUMNS_AVAILABLE.nazev(),
    COLUMNS_AVAILABLE.popis(),
    COLUMNS_AVAILABLE.exkluzivita(),
    COLUMNS_AVAILABLE.pozadavekSmena(),
    COLUMNS_AVAILABLE.maxPocetPozadavku()
  ];
  return useMemo(() => [columns], []);
}
